import { render, staticRenderFns } from "./Tocas.vue?vue&type=template&id=1d756bbe&"
import script from "./Tocas.vue?vue&type=script&lang=js&"
export * from "./Tocas.vue?vue&type=script&lang=js&"
import style0 from "./Tocas.vue?vue&type=style&index=0&id=1d756bbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports